import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {useTranslation} from '@/translations/i18n'
import {useFormContext, useWatch} from 'react-hook-form'
import {accessTypeKeyNameToDefaultDuration} from '@/features/agenda/utils'
import {AccessFormValidationSchema} from '@/features/accesses/formSchemas'
import {useMemo} from 'react'
import {calculateAccessRateCode} from '@/utilities/utils'

export const AccessInfoFields = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<AccessFormValidationSchema>()
    const accessType = useWatch({control, name: 'accessType'})
    const duration = useMemo(
        () => accessType && accessTypeKeyNameToDefaultDuration[accessType.accessType],
        [accessType]
    )
    const project = useWatch({control, name: 'project'})
    const rateCode = useMemo(
        () =>
            project &&
            calculateAccessRateCode({
                sector: project.sector,
                serviceType: project.patient.serviceType,
                assistiveRegime: project.assistiveRegime || undefined
            }),
        [project]
    )
    return (
        <Grid columns={2} columnGap={4} fullWidth>
            <Flexbox direction="column" gap={1}>
                <Text size="textSm" weight="500" palette="neutral" shade="700">
                    {t('accesses:rate')}
                </Text>
                <Text size="textSm" palette="neutral" shade="950">
                    {rateCode || '-'}
                </Text>
            </Flexbox>

            <Flexbox direction="column" gap={1}>
                <Text size="textSm" weight="500" palette="neutral" shade="700">
                    {t('commons:duration')}
                </Text>
                <Text size="textSm" palette="neutral" shade="950">
                    {duration || '-'}
                </Text>
            </Flexbox>
        </Grid>
    )
}
